import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import { App } from './App';
import '@growup/ui/styles.css';
import './index.css';

const container = document.getElementById('root');

if (!container) {
  throw new Error('Elemento #root em falta no index.html');
}

createRoot(container).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
